<template>
    <div id="director">
        <Banner title="理事長的話" :breadcrumbs="breadcrumbs" type="society"></Banner>
        <div class="container learning">
            <div class="center_title">
                <Title en="From The President" chtFirst="理事長" chtSecond="的話" :center="true"></Title>
            </div>
            <Language @getLanguage="myLanguage"></Language>
            <section class="content">
                <div class="foreword">
                    <div class="img">
                        <img :src="img" alt="理事長" />
                    </div>
                    <div class="text">
                        <h4>{{Language.title}}</h4>
                        <p v-for="(p,index) in Language.foreword" :key="index">{{p}}</p>
                    </div>
                </div>
                <div class="secword">
                    <p v-for="(o,index) in Language.content" :key="index">{{o}}</p>
                </div>
                <div
                    class="name"
                    :class="{'font_big':Language.type=='cht'}"
                >{{Language.Name}}</div>
            </section>
        </div>
    </div>
</template>

<script>
import Language from "@/components/switchLanguage";
export default {
    name: "director",
    components: {
        Language
    },
    props: {},
    data() {
        return {
            breadcrumbs: [
                {
                    url: "/",
                    title: "首頁"
                },
                {
                    title: "學會簡介"
                },
                {
                    url: "/Society/Words",
                    title: "理事長的話"
                }
            ],
            img: require("@/assets/info/person4.jpg"),

            Language: {},
            cht: {
                type: "cht",
                Name: "理事長 鄭成國 謹識",
                title: "尊敬的各位會員先進朋友",
                foreword: [
                    "新的一年開始了，讓我衷心祝願大家萬事如意、心想事成。",
                    "中華民國視網膜醫學會已走過了12年，在眾多前任理事長，包括創會的劉榮宏院長、以及許淑娟、楊中美、陳世真、楊長豪、和陳珊霓等傑出的教授和主任們的辛苦努力下，本會務蒸蒸日上，會員人數不斷增長。",
                    "我們不僅定期舉辦國內研討會，更積極擴展與其他國家視網膜醫學會的交流。",
                    "當然，我們也是國內醫療及健保政策的重要咨詢與參與者。我們致力於參與相關決策，以確保眼科領域的專業意見能得到有效表達和實踐。第七屆理監事會已於去年底完成選舉，也非常歡迎幾位新血加入理監事會的陣容，我們將秉持過去的傳統，持續為會員服務。"
                ],
                content: [
                    "未來，我們仍將維持每年兩次的Retina Club原則，由各地不同的醫院輪流舉辦，鼓勵會員分享臨床上有趣、爭議性、特殊不易診斷或具有教育意義的案例，以及創新手術技巧，以達到集思廣益、教學相長的目的。我們的年會將持續邀請國內外專業專家，分享最新的臨床研究、藥物發展和手術技巧給予會員。除此以外，我們也將定期舉辦小型學習會或工作坊，聚焦於新科技的應用和新治療方案的實踐。以加強我們的學術水準，讓會員更深入地了解和掌握最新的醫學發展。",
                    "我們每年都會舉辦年輕醫師的論文競賽，優勝者將獲得獎金及參與國際會議的機會，這是他們與國際交流的寶貴機會。在與國際視網膜界的交流方面，我們每年都參與台日韓三國舉辦的Asia Retina Congress (ARC)，2024年將在首爾舉行，而2025年將回到台北舉行。這項國際會議對與韓國和日本醫師的交流有極大的助益，也將擴大我們在東亞地區的影響力。此外，感謝國際事務委員會召集人許淑娟常務理事的努力，每兩年在Euretina年會的International Retina Day中介紹我們的研究成果，受到了相當熱烈的回響，進一步提升了我們的國際知名度。",
                    "最後，感謝各位會員多年來的支持，才使得中華民國視網膜醫學會能有今日的發展。我們歡迎會員隨時提出建議，讓我們的學會不斷茁壯成長。非常感謝大家！"
                ]
            },
            en: {
                type: "en",
                Name: "President Cheng-Kuo Cheng",
                title: "Dear esteemed members and friends:",
                foreword: [
                    "The new year has begun, and I sincerely wish you all the best and success in everything you do.",
                    "Taiwan Retina Society has gone through 12 years of development. With the hard work of numerous former presidents, including the founding president, Dr. Jorn-hon Liu, as well as Professors Shwu-Jiuan Sheu, Chung-May Yang, Shih-Jen Chen, Chang-Hao Yang, and San-Ni Chen, our society has thrived, and the number of members continues to grow. We not only regularly hold domestic symposiums but also actively expand exchanges with other international retina societies. Of course, we also play an important role in advising and participating in domestic medical and health insurance policies. We are committed to participating in relevant decision-making processes to ensure that professional opinions in the field of ophthalmology are effectively expressed and implemented. The elections for the seventh Board of Directors and Supervisors were completed at the end of last year, and we warmly welcome new members to join the board. We will continue to uphold the traditions and serve our members. "
                ],
                content: [
                    "In the future, we will maintain the principle of holding the Retina Club twice a year, with different hospitals taking turns to host. This will encourage members to share interesting, controversial, diagnostically challenging, or educationally significant clinical cases, as well as innovative surgical techniques, to promote mutual learning and education. Our annual meeting will continue to invite domestic and international experts to share the latest clinical research, drug developments, and surgical techniques with our members. In addition, we will also regularly hold small-scale workshops or learning sessions, focusing on the application of new technologies and the implementation of new treatment plans. This will enhance our academic standards and enable members to gain a deeper understanding and mastery of the latest medical developments.",
                    "Every year, we hold a paper competition for young doctors, and the winners are rewarded with cash prizes and the opportunity to participate in international conferences. This is a valuable opportunity for them to engage in international exchanges. In terms of international exchanges in the field of retinal medicine, we participate in the Asia Retina Congress (ARC) organized by Taiwan, Japan, and South Korea every year. The 2024 congress will be held in Seoul, and the 2025 congress will return to Taipei. This international conference greatly benefits the exchange with doctors from Korea and Japan and will expand our influence in East Asia. Additionally, we would like to thank the efforts of Director Hsu Shu-chuan, the convener of the International Affairs Committee, for introducing our research achievements during the International Retina Day at the biennial Euretina meeting. This has received a warm response and further enhanced our international reputation.",
                    "Finally, I would like to express my gratitude to all the members for their support over the years, which has contributed to the development of the Retina Society of the Republic of China. We welcome members to provide suggestions at any time, allowing our society to continuously grow and prosper. Thank you all very much.",
                ]
            }
        };
    },
    methods: {
        myLanguage(e) {
            this.Language = this[e];
            // console.log(this.Language);
        }
    },
    computed: {},
    created() {
        this.Language = this.cht;
        // location.href = '/'
    },
    mounted() {},
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#director .foreword {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    line-height: 2;
}
#director .foreword .img {
    width: 25%;
}
#director .foreword .img img {
    display: block;
    margin: auto;
    width: 100%;
}
#director .foreword .text {
    width: 70%;
}
#director .foreword .text p,
#director .secword p,
#director .end p {
    padding: 10px 0;
    color: #666;
    line-height: 2;
}
#director .end h6 {
    text-align: center;
    padding: 10px 0;
}
#director .end .image {
    width: 60%;
    margin: auto;
    margin-bottom: 20px;
}
#director .end .image img {
    width: 100%;
}
#director .name {
    padding-top: 60px;
    text-align: right;
}
#director .name.font_big {
    font-size: 1.75rem;
}
@media screen and (max-width: 767px) {
    #director .foreword .img {
        width: 80%;
        margin: auto;
        margin-bottom: 20px;
    }
    #director .foreword .text {
        width: 100%;
    }
    #director .name {
        text-align: center;
    }
    #director .end .image {
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/director.vue